import { FaTimes, FaFilePdf, FaDownload, FaSpinner } from "react-icons/fa";
import styles from "../../styles/detailModal.module.css"
import {cn} from "../../../../utils/cn"
function ReportDetailModal({
  onClose,
  report,
  onViewPdf,
  onDownloadPdf,
  loadingPdf,
}) {
  return (
    <div className="modal-overlay">
      <div className={`modal-content ${styles.reportModal}`}>
        {/* Encabezado */}
        <div className="modal-header">
          <div>
            <h2 className={styles.reportModalTitle}>
              Detalle del Reporte
            </h2>
            <span className={styles.reportModalSubtitle}>
              Información del Certificado
            </span>
          </div>

          <button
            type="button"
            className="modal-close-btn"
            onClick={onClose}
          >
            <FaTimes />
          </button>
        </div>

        {/* Contenido */}
        <div className={styles.reportModalBody}>
          <div className={styles.reportDetailsGrid}>
            <div className={styles.reportDetailItem}>
              <label className={styles.reportDetailLabel}>Folio</label>
              <span className={`${styles.reportDetailValue} ${styles.reportFolio}`}>
                {report?.folio}
              </span>
            </div>

            <div className={styles.reportDetailItem}>
              <label className={styles.reportDetailLabel}>
                Tipo de Certificado
              </label>
              <span className={styles.reportDetailValue}>
                {report?.tipoLabel || report?.tipo}
              </span>
            </div>

            <div className={styles.reportDetailItem}>
              <label className={styles.reportDetailLabel}>Titular</label>
              <span className={styles.reportDetailValue}>
                {report?.titular}
              </span>
            </div>

            {report?.curp && (
              <div className={styles.reportDetailItem}>
                <label className={styles.reportDetailLabel}>CURP</label>
                <span className={styles.reportDetailValue}>
                  {report?.curp}
                </span>
              </div>
            )}

            {report?.rfc && (
              <div className={styles.reportDetailItem}>
                <label className={styles.reportDetailLabel}>RFC</label>
                <span className={styles.reportDetailValue}>
                  {report?.rfc}
                </span>
              </div>
            )}

            <div className={styles.reportDetailItem}>
              <label className={styles.reportDetailLabel}>
                Fecha de Emisión
              </label>
              <span className={styles.reportDetailValue}>
                {report?.fecha}
              </span>
            </div>

            <div className={styles.reportDetailItem}>
              <label className={styles.reportDetailLabel}>
                Emitido por
              </label>
              <span className={styles.reportDetailValue}>
                {report?.usuario}
              </span>
            </div>

            <div className={styles.reportDetailItem}>
              <label className={styles.reportDetailLabel}>Estado</label>

              <span
                className={cn(
                  styles.reportStatusBadge,
                  report?.estado === "VIGENTE"
                    ? styles.reportStatusValid
                    : styles.reportStatusInvalid
                )}
              >
                {report?.estado}
              </span>
            </div>
          </div>

          {/* Observaciones */}
          <div className={styles.reportObservations}>
            <label className={styles.reportDetailLabel}>
              Observaciones
            </label>

            <textarea
              value={report?.observaciones || "Sin observaciones"}
              readOnly
              className={styles.reportObservationsTextarea}
            />
          </div>
        </div>

        {/* Acciones */}
        <div className={styles.reportModalFooter}>
          <button
            type="button"
            className={cn("btn-primary", styles.reportSecondaryButton)}
            onClick={onViewPdf}
            disabled={loadingPdf}
          >
            {loadingPdf ? (
              <FaSpinner className={styles.reportLoadingIcon} />
            ) : (
              <FaFilePdf className={styles.reportPdfIcon} />
            )}
            Ver PDF
          </button>

          <button
            type="button"
            className={cn("btn-primary", styles.reportSecondaryButton)}
            onClick={onDownloadPdf}
          >
            <FaDownload className={styles.reportDownloadIcon} />
            Descargar PDF
          </button>

          <button
            type="button"
            className="btn-primary"
            onClick={onClose}
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}


export default ReportDetailModal;
